var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.689 19.82a.613.613 0 0 1-.189-.436.592.592 0 0 1 .189-.436L14.947 12 7.69 5.052a.615.615 0 0 1-.189-.436.593.593 0 0 1 .189-.436.646.646 0 0 1 .455-.18.668.668 0 0 1 .455.18l7.712 7.384A.616.616 0 0 1 16.5 12a.593.593 0 0 1-.189.435L8.6 19.82a.645.645 0 0 1-.455.181.668.668 0 0 1-.455-.18Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;